import EventCalendar from '../pages/EventCalendar';

const eventCalendarRoute = {
  public: [],
  auth: [
    {
      name: 'event_calendar',
      path: '/maintenance/event-calendar',
      permissions: [
        'admin',
        'RSM',
        'KASROM',
        'KASOM',
        'KASM',
        'SAM',
        'KASH',
        'HTAM',
        'NSM-SPARTAN',
        'NSM-HOSPITAL',
        'SD',
        'GPM',
        'COO',
        'EXECUTIVE',
      ],
      component: EventCalendar,
    },
  ],
};

export default eventCalendarRoute;
